export const headerLineParser = /([A-Z]{2})([A-Z]{2})([0-9]{2}) ([A-Z]{4}) ([0-9]{6})/;

export const icaoRegex = /(?:^| )([A-Z]{4}) /;
export const dateRegex = /([0-9]{6})Z/;
export const windRegex = /([0-9]{5}KT)| ([0-9]{5}G[0-9]{2}KT)| (VRB[0-9]{2}KT)| (VRB[0-9]{2}G[0-9]{2}KT)/;
export const windVarRegex = / (\d{3}[vV]\d{3})/;
export const visibilityRegex = / ([0-9]{4}) | ([0-9]{4})NDV | ([0-9]{1,2}SM) | (1\/[2-8]{1}SM) | ((?:[1-5] )?[1-3]\/[2-8]{1}SM) | (P6SM) /;
export const weatherRegex = /\s((?:\+|\-|VC)?(?:BC|BL|BR|DR|DS|DU|DZ|FG|FC|FU|FZ|GR|GS|HZ|IC|MI|PL|PO|RA|SA|SG|SH|SN|SQ|SS|TS|VA|UP|RE)+)/gm; // TODO: Could be generated from the object in MetarTafAbbreviations
export const weatherAbbreviationRegex = /BC|BL|BR|DR|DS|DU|DZ|FG|FC|FU|FZ|GR|GS|HZ|IC|MI|PL|PO|RA|SA|SG|SH|SN|SQ|SS|TS|VA|UP|RE/g;
export const tempRegex = / ([0-9]{2}\/[0-9]{2})/;
export const qnhRegex = / Q([0-9]{4})/;

export const cloudRegex = /((?:[A-Z]{3}|[/]{3})(?:[0-9]{3}|[/]{3}))(CB|TCU|[/]{3})?/g;
export const cloudSeparator = /([A-Z]{3}|[/]{3})([0-9]{3}|[/]{3})(CB|TCU|[/]{3})?/;
export const verticalVisibility = /VV([0-9]{3}|[///]*)/;

export const metarRwyVisualRegex = /(R\d{1,2}[LRC]?\/[PM]?\d{4}[UDV]?)/g;
export const rwySeparator = /R(\d{1,2}[LRC]?)\/([PM]?)(\d{4})([UDV]?)/;
export const metarChangeRegex = /(FM[0-9]{4}|AT[0-9]{4}|TL[0-9]{4})/;

                                // Match lines that does not include the word "METAR", but instead just includes the ICAO and datetime.
export const metarBulletinRegex = /(?:METAR\s|METAR COR\s)?[A-Z]{4} [0-9]{6}Z .*?=/g;
export const speciBulletinRegex = /(?:SPECI\s|SPECI COR\s)?[A-Z]{4} [0-9]{6}Z .*?=/g; 
export const tafBulletinRegex = /(?:TAF\s|TAF AMD\s|TAF COR\s)?[A-Z]{4} [0-9]{6}Z .*?=/g;

export const tafGroupRegex = /(?:((?:[0-9]{4}\/[0-9]{4}|TEMPO|BECMG|FM[0-9]{4,6}|PROB(?:30|40) TEMPO|PROB(?:30|40)) [a-zA-Z0-9 +-/]+?)(?=TEMPO|BECMG|FM[0-9]{4,6}|PROB(?:30|40)|[0-9]{4}\/[0-9]{4}|=|$))/gm;
export const tafGroupDateRegex = /([0-9]{4}\/[0-9]{4})|FM([0-9]{4,6})/;
export const tafValidityRegex = /([0-9]{4}\/[0-9]{4})/;
export const tafChangeRegex = /(TEMPO|BECMG|FM[0-9]{4,6}) /;
export const tafProbRegex = /PROB(30|40) /;
export const tafTempRegex = /((?:TN|TX)[0-9]{2}\/[0-9]{4})Z/g;

// Used to split current weather and forecasted weather in metar
export const metarWeatherSplitRegex = /(?=BECMG|TEMPO)/;